module.exports = __webpack_public_path__ + "img/logo-leonton.49762db7.svg";